import './index.scss';

const carouselText = [
  {text: "qualité ?", color: "red"},
  {text: "proximité ?", color: "orange"},
  {text: "confiance ?", color: "yellow"}
]

async function typeSentence(sentence, eleRef, delay = 100) {
  const letters = sentence.split("");
  let i = 0;
  while(i < letters.length) {
    await waitForMs(delay);
    document.getElementById(eleRef).append(letters[i]);
    i++;
  }
  return;
}


function waitForMs(ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

async function deleteSentence(eleRef) {
  const sentence = document.getElementById(eleRef).innerText;
  const letters = sentence.split("");
  let i = 0;
  while(letters.length > 0) {
    await waitForMs(100);
    letters.pop();
    document.getElementById(eleRef).innerHTML = letters.join("");
  }
}

async function carousel(carouselList, eleRef) {
    var i = 0;
    while(true) {
      // updateFontColor(eleRef, carouselList[i].color)
      await typeSentence(carouselList[i].text, eleRef);
      await waitForMs(1500);
      await deleteSentence(eleRef);
      await waitForMs(500);
      i++
      if(i >= carouselList.length) {i = 0;}
    }
}

carousel(carouselText, "feature-text");

LottieInteractivity.create({
  player: '#firstLottie',
  mode: 'scroll',
  actions: [
      {
          visibility:[0.15,0.85],
          type: 'seek',
          frames: [0, 180],
      },
  ]
});

LottieInteractivity.create({
  player: '#secondLottie',
  mode: 'scroll',
  actions: [
      {
          visibility:[0.15,0.85],
          type: 'seek',
          frames: [0, 120],
      },
  ]
});

LottieInteractivity.create({
  player: '#thirdLottie',
  mode: 'scroll',
  actions: [
      {
          visibility:[0.15,0.85],
          type: 'seek',
          frames: [0, 311],
      },
  ]
});
